import { createSlice } from '@reduxjs/toolkit'
import { fetchAnalyticsReports } from './thunks/analytics';

const initialState = {
  data: "",
  isLoading: false,
  error: null,
  filteredCaption: "",
  activeTab: "ratio",
  entriesScreenColumns:{
    "Head": {
        name: 'head',
        type: "insi",
        isSelected: false
    },
    "Caption": {
        name: 'caption',
        type: "insi",
        isSelected: false
    }
  },
}

const analyticsReport = createSlice({
    name: 'ANALYTICSREPORTSLICE',
    initialState,
    reducers: {
      addSymbols(state, action){
          state.availableSymbols = action.payload
      },
      setAnalyticsFilteredCaption(state, action){
        state.filteredCaption = action.payload
      },
      setActiveTab(state, action) {
        state.activeTab = action.payload
      },
      entriesScreenColumnsHandler: (state, action) => {
        const { column } = action.payload;
        if (column && state.entriesScreenColumns[column]) {
          state.entriesScreenColumns[column].isSelected = !state.entriesScreenColumns[column].isSelected;
        }
      }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAnalyticsReports.pending, (state) => {
          state.isLoading = true
        })
        builder.addCase(fetchAnalyticsReports.fulfilled, (state, action) => {
          state.isLoading = false
          state.data = action.payload
        })
        builder.addCase(fetchAnalyticsReports.rejected, (state, action) => {
          state.isLoading = false
          state.error = action.error.message
          state.data = null
        })
    }
});

export const { addSymbols, data, setAnalyticsFilteredCaption, setActiveTab, entriesScreenColumnsHandler } = analyticsReport.actions

export default analyticsReport;